import appID from './appID';
import ForStractionServiceAPI, { ApiClient } from 'for-straction-service-api';

// TODO something better
// own client generator?
ApiClient.instance.basePath = API_PATH.replace(/\/+$/, '');

// original code is

// /**
//  * Parses an ISO-8601 string representation of a date value.
//  * @param {String} str The date value as a string.
//  * @returns {Date} The parsed date object.
//  */
// exports.parseDate = function(str) {
//   return new Date(str.replace(/T/i, ' '));
// };

// but 'T' replacement makes date string not ISO-8601 compliant and not parsable by half of browsers
ApiClient.parseDate = str => new Date(str);

// TODO migrate to OpenAPI 3.0 which is next (and renamed) version of Swagger and supports nullable values
// currently there is a hack - all non-nullable properties in JSON have "default" field
// our client checks it and make APIPropTypes and default values to validate/assign null when needed
// and here we make Swagger client pass any null coming from server as is, which is not entirely accurate, but should work since server is the source of API
// this doesn't work for dates https://github.com/swagger-api/swagger-codegen/blob/master/modules/swagger-codegen/src/main/java/io/swagger/codegen/languages/JavascriptClientCodegen.java#L596

// constructFromObject with properties of type Date does not work correctly because of this convertToType part:
// case 'Date':
//      return this.parseDate(String(data));
// if data is Date, String serializes it to human readable format ("Tue Jun 20 2017 15:51:20 GMT+0300 (FLE Daylight Time)")
// instead of ISO-8601 
// such format should not even be parsable as Date according to MDN
// but somehow it works, losing milliseconds part and producing date slightly different from what is stored in DB causing troubles to search and edit
// why the hell is it implemented this way?
const convertToType = ApiClient.convertToType;
ApiClient.convertToType = function (data, type) {
    return data !== null ?
        type === 'Date' && data instanceof Date ? convertToType.call(this, data.toISOString(), type) :
            convertToType.apply(this, arguments) :
        null
};


function wrapMethod(apiName, methodName, method) {
    var optsRE = /opts\['(.*?)'\]/g;
    var opts = (method.toString().match(optsRE) || []).map(o => o.replace(optsRE, '$1'));
    var parameters = method.toString().replace(/^function\s*\(/, '').replace(/\)[\s\S]*$/, '').replace(/\s*/g, '').split(',');
    var prefix = apiName + '.' + methodName + '(' + parameters.join(', ') + ') is being called with invalid arguments:';
    var suffix = '\nSee more information at https://manmadesoftware.atlassian.net/wiki/display/STR/Using+Swagger+API+Client or ' + location.origin + '/app/node_modules/for-straction-service-api/docs/' + apiName + '.md#' + methodName;
    var result = function () {
        var error = '';
        if (parameters.length > arguments.length) {
            error += (!error ? prefix : '') + '\n\t- Got less arguments than expected. Probably you missed "opts".';
        }
        if (parameters.length < arguments.length) {
            error += (!error ? prefix : '') + '\n\t- Got more arguments than expected. Probably you did not wrap optional arguments to "opts".';
        }
        for (var i = 0; i < parameters.length; i++) {
            switch (true) {
                case parameters[i] === '_4SAPIAppID' && arguments[i] !== appID:
                    error += (!error ? prefix : '') + '\n\t- "_4SAPIAppID" is not equal to current appID. Server will reject such request.';
                    break;

                case parameters[i] === 'body' && (typeof arguments[i] !== 'object' || !arguments[i]):
                    error += (!error ? prefix : '') + '\n\t- "body" is not an instance of entity. Entity typed parameter should always come second regardless of it\'s position in backend method.';
                    break;

                // TODO decide what "instance of entity" means in JS:
                // type should be somehow identifiable from an "instance", instance should be easily storable in an immutable store and passable partially from/to the server
                // and most important they should help in detecting malformed objects
                // Swagger client classes and plain objects with "EntityType" property didn't really work
                // case parameters[i] === 'body' && !arguments[i].EntityType:
                //     console.warn(prefix + '"body" is an object, but seems not to be an instance of entity. Fill it with all properties from defaults.SomeEntity' + suffix);
                //     break;

                case parameters[i] === 'opts' && (!arguments[i] || typeof arguments[i] !== 'object'):
                    error += (!error ? prefix : '') + '\n\t- "opts" is not an object. If backend method has any Optional parameters, these parameters should be passed as fields of opts object. The object always should come as last argument before callback and can not be omitted. Fields can be omitted in which case backend will use default value.';
                    break;

                case parameters[i] === 'opts':
                    for (var j in arguments[i]) {
                        if (arguments[i].hasOwnProperty(j) && opts.indexOf(j) === -1) {
                            error += (!error ? prefix : '') + '\n\t- Unknown parameter "opts.' + j + '".';
                        }
                    }
                    break;

                case parameters[i] === 'callback' && typeof arguments[i] !== 'function':
                    error += (!error ? prefix : '') + '\n\t- "callback" is not a function. No actions will be dispatched after request is finished and you won\'t be able to handle it any other way.';
                    break;
            }
        }

        if (error) {
            throw new TypeError(error + suffix);
        }

        return method.apply(this, arguments);
    }

    result.Length = method.length;

    return result;
}

function wrapAPIConstructor(name, constructor) {
    return function (apiClient) {
        constructor.apply(this, arguments);
        if (DEBUG) {
            for (var i in this) {
                if (this.hasOwnProperty(i) && i !== 'apiClient') {
                    this[i] = wrapMethod(name, i, this[i]);
                }
            }
        }

        this.name = name.slice(0, -3);

        return this;
    }
}

// for some reason swagger-codegen merges all TrackingLevel*Api methods under one class called TrackingLevelItemApi
// we have to unpack them since other code expects one API class per entity
ForStractionServiceAPI.TrackingLevel1ItemApi = ForStractionServiceAPI.TrackingLevelItemApi;
ForStractionServiceAPI.TrackingLevel2ItemApi = ForStractionServiceAPI.TrackingLevelItemApi;
ForStractionServiceAPI.TrackingLevel3ItemApi = ForStractionServiceAPI.TrackingLevelItemApi;
ForStractionServiceAPI.TrackingLevel4ItemApi = ForStractionServiceAPI.TrackingLevelItemApi;

//TODO is it possible to create this stuff during webpack bundling?
for (let i in ForStractionServiceAPI) {
    if (i.indexOf('Api') !== -1) {
        ForStractionServiceAPI[i] = wrapAPIConstructor(i, ForStractionServiceAPI[i])
    }
};
